import gql from 'graphql-tag'

export const REGISTER_FCM_TOKEN = gql`
mutation RegisterFCMToken($input: RegisterFCMTokenInput!) {
  registerFCMToken(input: $input) {
    isSuccessful
    message
    registerFCMToken {
      message
    }
  }
}
`

export const UNREGISTER_FCM_TOKEN = gql`
mutation UnregisterFCMToken($input: UnRegisterFCMTokenInput!) {
  unregisterFCMToken(input: $input) {
    isSuccessful
    message
    unregisterFCMToken {
      message
    }
  }
}
`
